export default "__VITE_ASSET__BiQgLVGI__"